import {
  InfoCircleOutlined,
  UserOutlined,
  IdcardOutlined,
  FileTextOutlined,
  SolutionOutlined,
  HomeOutlined,
  TeamOutlined,
  AuditOutlined,
  EllipsisOutlined,
  UserSwitchOutlined,
  CopyOutlined,
  BranchesOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

/**

 * @param {boolean} hasHostel
 * @param {boolean} showAdminInfo
 */
export const getEmployeeFlowSteps = (
  hasHostel = false,
  showAdminInfo = true
) => {
  const steps = [
    {
      stage: "BASIC_INFO",
      path: "/employeeFlow/BasicInfo",
      label: "Basic Info",
      icon: <InfoCircleOutlined />,
    },
  ];

  // ✅ CONDITIONAL ADMIN INFO
  if (showAdminInfo) {
    steps.push({
      stage: "ADMIN_INFO",
      path: "/employeeFlow/AdminInfo",
      label: "Admin Info",
      icon: <UserSwitchOutlined />,
    });
  }

  steps.push(
    {
      stage: "DEMOGRAPHIC_INFO",
      path: "/employeeFlow/DemographicDetails",
      label: "Demographic Details",
      icon: <CopyOutlined />,
    },
    {
      stage: "OWNERSHIP_AND_LEGAL_INFO",
      path: "/employeeFlow/OwnershipInfo",
      label: "Ownership Info",
      icon: <SolutionOutlined />,
    },
    {
      stage: "DOCUMENT_INFO",
      path: "/employeeFlow/DocumentInfo",
      label: "Document Info",
      icon: <FileTextOutlined />,
    },
    {
      stage: "OTHER_DETAILS",
      path: "/employeeFlow/OtherDetails",
      label: "Other Details",
      icon: <BranchesOutlined />,
    }
  );

  if (hasHostel) {
    steps.push({
      stage: "HOSTEL_DETAILS",
      path: "/employeeFlow/HostelDetails",
      label: "Hostel Details",
      icon: <HomeOutlined />,
    });
  }

  steps.push(
    {
      stage: "SOCIAL_INFO",
      path: "/employeeFlow/SocialInfo",
      label: "Social Info",
      icon: <TeamOutlined />,
    },
    {
      stage: "AWAITING_APPROVAL",
      path: "/employeeFlow/ApprovalInfo",
      label: "Approval Info",
      icon: <FileDoneOutlined />,
    }
  );

  return steps;
};

/* ---------------- HELPERS ---------------- */

export const getNextRouteFromStage = (stage, steps) => {
  const index = steps.findIndex((s) => s.stage === stage);
  return steps[index + 1]?.path;
};

export const getStageFromPath = (path, steps) => {
  const step = steps.find((s) => s.path === path);
  return step?.stage;
};
